import React from 'react';
import { Container, Card, CardBody, Button } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../../helpers/intlMessage';

function Grid ({
  lista,
  pagina,
  totalItens,
  totalItensPage,
  setPagina,
  onclickLine,
  oncClickImprimirNotificacoes
}) {
  function Footer ({ totalItens }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }}>
            <IntlMessage id = "dashboards.reports.totalCriticalExams"/> {totalItens}
          </span>
        </span>
      </div>
    );
  }
  return (
    <Card>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={e => onclickLine(e)}
            value={lista}
            //pageLinkSize={20}
            responsive={true}
            selectionMode='single'
            style={{ height: '100%' }}
            columnResizeMode='expand'
            scrollable={true}
            scrollWidth='100%'
            resizableColumns={lista.length >= 1}
            reorderableColumns={lista.length >= 1}
            first={(pagina - 1) * totalItensPage}
            rows={totalItensPage}
            lazy={true}
            paginator={lista.length > 0}
            emptyMessage={<IntlMessage id = "dashboards.reports.noResultsFound"/>}
            alwaysShowPaginator={false}
            autoLayout={true}
            totalRecords={totalItens}
            onPage={event => setPagina(event.page + 1)}
            footer={<Footer totalItens={totalItens} />}
          >
            <Column 
            sortable={false} 
            field='select' 
            style={{ width: '25px' }} 
            />
            <Column 
            field='nrExame' 
            style={{ width: '100px' }} 
            header={<IntlMessage id = "dashboards.reports.exam"/>}
            />
            <Column
              field='statusFormatted'
              style={{ width: '150px' }}
              header={<IntlMessage id = "dashboards.reports.status"/>}
            />
            <Column
              field='paciente'
              style={{ width: '200px' }}
              header={<IntlMessage id = "dashboards.reports.patientCivilRegistry"/>}
            />
            <Column
              field='pacienteNomeSocial'
              style={{ width: '200px' }}
              header={<IntlMessage id = "dashboards.reports.socialName"/>}
            />
            <Column 
            field='medico'
             style={{ width: '200px' }} 
             header={<IntlMessage id = "dashboards.reports.doctor"/>}
             />
            <Column 
            field='exame' 
            style={{ width: '250px' }} 
            header={<IntlMessage id = "dashboards.reports.type"/>}
            />
            <Column
              field='dataPedido'
              style={{ width: '150px' }}
              header={<IntlMessage id = "dashboards.reports.dateRequest"/>}
            />
            <Column
              field='prontuario'
              style={{ width: '120px' }}
              header={<IntlMessage id = "dashboards.reports.medicalRecord"/>}
            />
            <Column
              field={e => (
                <Button
                  color='link'
                  className='btn btn-imprimir'
                  onClick={() => oncClickImprimirNotificacoes(e)}
                >
                  <i className='icons-btn mv-basico-imprimir'></i> 
                  <IntlMessage id = "dashboards.reports.printOut"/>
                </Button>
              )}
              style={{ width: '150px' }}
              header={<IntlMessage id = "dashboards.reports.notifications"/>}
            />
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Grid;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Grid/index.js